// Only Ethereum is supported as the single network/asset on this platform.

export const SUPPORTED_SYMBOLS = new Set<string>(['ETH']);

export function isSupportedCrypto(symbol: string): boolean {
  return SUPPORTED_SYMBOLS.has(symbol.toUpperCase());
}
